import { ArtistType } from '@/types/artist.type'
import { components } from '@/types/swagger/model/swagger-card.type'
import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

export interface DigitalCard {
  cardId: number
  cardName: string
  description: string
  imageUrl: string
  cardType: 'digital' | 'physical'
  isNew: boolean
}

interface State {
  drawStep: number
  motionPageVisible: boolean
  draw1DigitalCard: DigitalCard
  draw10DigitalCard: DigitalCard[]
  drawType: 'draw1' | 'draw10'
  drawArtistType: ArtistType
  newlyCompletedCardSets: components['schemas']['com.dreamuscompany.digitalcard.dto.NewlyCompletedCardSetInfo'][]
}

interface Action {
  changeDrawStep: ({ drawStep }: { drawStep: State['drawStep'] }) => void
  changeMotionPageVisible: ({ motionPageVisible }: { motionPageVisible: State['motionPageVisible'] }) => void
  changeDraw1DigitalCard: ({ draw1DigitalCard }: { draw1DigitalCard: State['draw1DigitalCard'] }) => void
  changeDraw10DigitalCard: ({ draw10DigitalCard }: { draw10DigitalCard: State['draw10DigitalCard'] }) => void
  changeDrawType: ({ drawType }: { drawType: State['drawType'] }) => void
  changeDrawArtistType: ({ drawArtistType }: { drawArtistType: State['drawArtistType'] }) => void
  changeNewlyCompletedCardSets: ({
    newlyCompletedCardSets,
  }: {
    newlyCompletedCardSets: State['newlyCompletedCardSets']
  }) => void
  resetDraw10DigitalCard: () => void
  resetDraw1DigitalCard: () => void
  resetNewlyCompletedCardSets: () => void
}

export const cardDrawStore = create<State & Action>()(
  devtools(
    (set) => ({
      drawStep: 0,
      motionPageVisible: false,
      draw1DigitalCard: {} as State['draw1DigitalCard'],
      draw10DigitalCard: [] as State['draw10DigitalCard'],
      drawType: 'draw1',
      drawArtistType: '',
      newlyCompletedCardSets: [] as State['newlyCompletedCardSets'],
      changeDrawStep: ({ drawStep }) => set(() => ({ drawStep }), undefined, 'cardDraw/changeDrawStep'),
      changeMotionPageVisible: ({ motionPageVisible }) =>
        set(() => ({ motionPageVisible }), undefined, 'cardDraw/changeMotionPageVisible'),
      changeDraw1DigitalCard: ({ draw1DigitalCard }) =>
        set(() => ({ draw1DigitalCard }), undefined, 'cardDraw/changeDraw1DigitalCard'),
      changeDraw10DigitalCard: ({ draw10DigitalCard }) =>
        set(() => ({ draw10DigitalCard }), undefined, 'cardDraw/changeDraw10DigitalCard'),
      changeNewlyCompletedCardSets: ({ newlyCompletedCardSets }) =>
        set(() => ({ newlyCompletedCardSets }), undefined, 'cardDraw/changeNewlyCompletedCardSets'),
      resetDraw10DigitalCard: () =>
        set(
          () => ({ draw10DigitalCard: [], newlyCompletedCardSets: [] as State['newlyCompletedCardSets'] }),
          undefined,
          'cardDraw/resetDraw10DigitalCard',
        ),
      resetDraw1DigitalCard: () =>
        set(
          () => ({
            draw1DigitalCard: {} as State['draw1DigitalCard'],
            newlyCompletedCardSets: [] as State['newlyCompletedCardSets'],
          }),
          undefined,
          'cardDraw/resetDraw1DigitalCard',
        ),
      resetNewlyCompletedCardSets: () =>
        set(
          () => ({ newlyCompletedCardSets: [] as State['newlyCompletedCardSets'] }),
          undefined,
          'cardDraw/resetNewlyCompletedCardSets',
        ),
      changeDrawType: ({ drawType }) => set(() => ({ drawType }), undefined, 'cardDraw/changeDrawType'),
      changeDrawArtistType: ({ drawArtistType }) =>
        set(() => ({ drawArtistType }), undefined, 'cardDraw/changeDrawArtistType'),
    }),
    { name: 'cardDrawStore' },
  ),
)
